<main>
    <h1>Netlify/Svelte/Fauna</h1>

    <DeleteCar />
    <CreateCar />
    <UpdateCar />
    <ReadCar />
    <ReadAllCars />
</main>

<script>
    import DeleteCar from './DeleteCar.svelte'
    import CreateCar from './CreateCar.svelte'
    import UpdateCar from './UpdateCar.svelte'
    import ReadCar from './ReadCar.svelte'
    import ReadAllCars from './ReadAllCars.svelte'
</script>